import React, { Component } from 'react';
import AuthenticationForm from './AuthenticationForm'
import AuthenticationModal from './AuthenticationModal'
import { withContext } from 'libs/context'
import { Button } from 'antd'
import http from 'libs/http';
class Authentication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowForm: true,
      authenticationAll: JSON.parse(window.localStorage.getItem('authority')).authenticationAll
    }
  }
  toAuthentication =() =>{
    if (this.state.authenticationAll) {
      this.setState({ isShowForm: false })
      this.addInit()
    } else {
      this.setState({content: '应账号实名制要求，身份认证后才可以发表内容，以保护帐号安全。', notAuthority: true})
    }
  }

  componentDidMount() {
    this.initShow()
  }
  changeTypeList =(e) => {
    this.setState({typeList: e.target.value})
  }
  isShowForm =() => {
    this.setState({visible: !this.state.visible})
  }
  addInit =() => {
    http.json('/sys/user/certify/addInit')
    .then(res => {
      res.changeTypeList = this.changeTypeList
      this.setState({ addInit: res })
    })
  }
  initShow =() => {
    const contentArr = ['应账号实名制要求，身份认证后才可以发表内容，以保护帐号安全。', '正在努力审核中，请耐心等待~', '', `当前账号认证未通过，请重新认证。`, '当前账号认证时间已过期，请重新认证，以便账号正常使用']
    const buttonTpl = [<Button key="submit" type="primary" onClick={this.toAuthentication}>认证</Button> ]
    if (this.state.authenticationAll) {
      http.json('/sys/user/certify/show')
      .then(res => {
        let isShowButton = res.status === 1 ? null : buttonTpl
        this.setState({content: contentArr[res.status], isShowButton, visible: res.status === 2 ? false : true, status: res.status, statusReason: res.statusReason})
      })
    } else {
      this.setState({content: contentArr[0], isShowButton:buttonTpl, visible: true})
    }
  }

  render() {
    const { isShowForm, addInit} = this.state
    return (
      <div>
        {!isShowForm
          ? <AuthenticationForm isShowForm={this.isShowForm} visible={true} {...addInit}/>
          : <AuthenticationModal {...this.state} toAuthentication={this.toAuthentication}/>
        }
      </div>
    )
  }
}

export default withContext('authority')(Authentication);